import { LinkRouterProps, Link } from '@anytag/router';
import { Button, ButtonProps } from './button';

export interface ButtonLinkProps
  extends Partial<
      Pick<
        ButtonProps,
        | 'title'
        | 'variant'
        | 'className'
        | 'prefixIcon'
        | 'suffixIcon'
        | 'loading'
        | 'disabled'
        | 'tooltip'
        | 'size'
        | 'color'
      >
    >,
    Omit<LinkRouterProps, 'title'> {
  rel?: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}

export const ButtonLink = ({
  to,
  href,
  title,
  variant,
  tooltip,
  loading,
  onClick,
  disabled,
  className,
  prefixIcon,
  size,
  suffixIcon,
  children,
  ...restProps
}: ButtonLinkProps) => (
  <Button
    size={size}
    title={title}
    tooltip={tooltip}
    loading={loading}
    variant={variant}
    disabled={disabled}
    className={className}
    prefixIcon={prefixIcon}
    suffixIcon={suffixIcon}
    component={Link}
    to={disabled ? undefined : to}
    href={disabled ? undefined : href}
    {...restProps}
  />
);
